/* ==========================================================================
   Casemira · page carte cadeau « Objet » (25/09/2026)
   Chargé par sections/casemira-gift-card-page.liquid, en defer, après
   variant-selects.js et product-info.js.

   1. LE MONTANT. Chaque montant est une variante native. Un choix (case du
      registre ou « Autre montant » valide) :
        - coche la radio native de <variant-selects> et dispatche un `change`
          bouillonnant : variant-selects.js publie optionValueSelectionChange,
          product-info.js confirme par la Section Rendering API, réécrit
          l'URL `?variant=`, input[name="id"], et dispatche `variant:changed` ;
        - écrit TOUT DE SUITE input[name="id"] (un clic sur « Ajouter au
          panier » avant la réponse du serveur part donc avec le bon montant),
          le montant de la carte et le libellé du bouton.
      Au retour du serveur (`variant:changed`, `change` sur input[name="id"]),
      tout est remis en phase depuis la variante réelle : c'est elle qui fait
      foi (lien profond `?variant=`, retour arrière).
   2. LE STYLE (26/09/2026 ; Style x Montant le 22/10/2026). Les pastilles
      sous la carte changent l'attribut data-style de la face (fond + encre,
      assets/giftcard-face.css) sans rechargement, et :
        - produit à deux options (Style, Montant) : cochent dans
          <variant-selects> la valeur d'option 1 de même POSITION que la
          pastille (le libellé est traduit, la position ne l'est pas) et
          dispatchent `change`, exactement comme un montant ; input[name="id"]
          prend tout de suite la variante (ce style, montant courant) ;
        - dans tous les cas : le champ caché properties[_style_id]
          (identifiant, masqué, en secours pour la page carte et les e-mails).
      LA TABLE [data-cmgp-map] vit dans <variant-selects> (le thème la
      remplace à chaque réponse du serveur) : elle est donc relue à chaque
      usage, jamais gardée en mémoire. Elle ne contient que les 96 montants du
      style courant (480 variantes dépassent la limite Liquid de 250).
   4. LES DEVISES (22/10/2026). Chaque montant porte c (prix réel, devise du
      visiteur) et e (montant facial en centimes d'euro, lu dans le libellé
      « 200 € »). Les pastilles 100/200/300/500 visent e ; « Autre montant »
      se saisit dans la devise du visiteur et vise le prix réel le plus proche
      (bornes = plus petit et plus grand prix réels). En euros, c = e : même
      comportement que le 26/09 (50 à 1 000 €, par tranche de 10 €).
   3. L'APERÇU. « Pour <prénom> » et le mot glissé sous la carte suivent les
      champs natifs du formulaire destinataire. Texte injecté avec
      textContent, jamais innerHTML. En « Pour moi », ni prénom ni mot.
   5. LE CARTOUCHE (22/10/2026, décision de Baptiste). « VALABLE JUSQU'AU
      <date> » : la carte est émise au paiement et vaut un an (réglage
      Shopify), donc date = aujourd'hui + 1 an, écrite par Intl.DateTimeFormat
      avec la locale et les options de la langue (clé card_date_intl :
      « fr-FR|numeric|short »), mois toujours en lettres. Trop long pour sa
      zone (47,92 cqw) : corps puis espacement réduits, en cqw.
   Aucun texte en dur : tout vient des attributs data-* posés par Liquid.
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__cmgp) return;
    root.__cmgp = 1;

    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    /* La table du sélecteur visible (voir variantSelects plus bas), relue à
       chaque appel : { si, s: [{i, ov, id}], a: [{c, id, ov, l}] }. */
    var mapCache = { node: null, val: null };
    function readMap() {
      var vs = variantSelects();
      var node = (vs && vs.querySelector('[data-cmgp-map]')) || $('[data-cmgp-map]');
      if (!node) return { si: -1, s: [], a: [] };
      if (mapCache.node === node && mapCache.val) return mapCache.val;
      var v = null;
      try { v = JSON.parse(node.textContent); } catch (e) { v = null; }
      /* Ancienne forme (tableau des montants seul) acceptée. */
      if (Array.isArray(v)) v = { si: -1, s: [], a: v };
      v = v || { si: -1, s: [], a: [] };
      v.s = v.s || []; v.a = v.a || [];
      v.byFace = {}; v.byId = {}; v.min = Infinity; v.max = -Infinity;
      v.a.forEach(function (m) {
        if (m.e == null) m.e = m.c;
        v.byFace[m.e] = m; v.byId[String(m.id)] = m;
        if (m.c < v.min) v.min = m.c;
        if (m.c > v.max) v.max = m.c;
      });
      mapCache = { node: node, val: v };
      return v;
    }
    var byFace = function (e) { return readMap().byFace[e]; };
    /* Le prix réel le plus proche (à égalité, le plus haut, comme l'arrondi
       à la dizaine du 26/09 : 375 € donne 380 €). */
    function nearest(cents) {
      var best = null;
      readMap().a.forEach(function (m) {
        if (!best) { best = m; return; }
        var d = Math.abs(m.c - cents), db = Math.abs(best.c - cents);
        if (d < db || (d === db && m.c > best.c)) best = m;
      });
      return best;
    }
    if (!readMap().a.length) return;

    var amountRadios = $$('[data-cmgp-amount]');
    var freeRadio = $('[data-cmgp-free-radio]');
    var freeRow = $('[data-cmgp-free-row]');
    var freeInput = $('[data-cmgp-free]');
    var freeHelp = $('[data-cmgp-free-help]');
    var freeMsg = $('[data-cmgp-free-msg]');
    var cardAmount = $('[data-cmgp-card-amount]');
    var cardTo = $('[data-cmgp-card-to]');
    var note = $('[data-cmgp-note]');
    var noteTo = $('[data-cmgp-note-to]');
    var noteMsg = $('[data-cmgp-note-msg]');
    var noteSend = $('[data-cmgp-note-send]');

    function data(name) { return root.getAttribute('data-' + name) || ''; }
    function form() { return root.querySelector('form[data-type="add-to-cart-form"]'); }
    function idInput() { var f = form(); return f && f.querySelector('input[name="id"]'); }
    function currentId() { var i = idInput(); return i ? String(i.value) : ''; }

    /* ---------- le bouton : « Ajouter au panier · 200 € » ---------- */
    function paintButton(m) {
      var f = form();
      var btn = f && f.querySelector('[name="add"]');
      var txt = btn && btn.querySelector('.btn__text');
      if (!txt || btn.hasAttribute('disabled')) return;
      txt.textContent = '';
      txt.appendChild(document.createTextNode(data('add-label')));
      var sep = document.createElement('span');
      sep.className = 'cmgp-atc__sep';
      sep.setAttribute('aria-hidden', 'true');
      sep.textContent = '·';
      var price = document.createElement('span');
      price.className = 'cmgp-atc__price';
      price.textContent = m.l;
      txt.appendChild(sep);
      txt.appendChild(price);
    }

    function paintCardAmount(m) {
      if (!cardAmount || cardAmount.textContent === m.l) return;
      cardAmount.textContent = m.l;
      cardAmount.classList.remove('is-new');
      void cardAmount.offsetWidth;
      cardAmount.classList.add('is-new');
    }

    function isFeatured(c) {
      return amountRadios.some(function (r) { return parseInt(r.value, 10) === c; });
    }

    function paintLedger(m, fromFree) {
      /* Tant que le visiteur tape dans « Autre montant », on reste en mode
         libre même si son montant correspond à une pastille (300 €). */
      var keepFree = !!fromFree || document.activeElement === freeInput;
      var featured = isFeatured(m.e) && !keepFree;
      amountRadios.forEach(function (r) { r.checked = featured && parseInt(r.value, 10) === m.e; });
      if (freeRadio) freeRadio.checked = !featured;
      if (freeRow) freeRow.classList.toggle('is-active', !featured);
      if (!featured && freeInput && !keepFree) freeInput.value = String(m.c / 100);
      if (featured && freeInput) freeInput.value = '';
      paintFreeValue();
    }

    function paintAll(m, fromFree) {
      paintLedger(m, fromFree);
      paintCardAmount(m);
      paintButton(m);
    }

    /* Le thème insère le nouveau <variant-selects> devant l'ancien et masque
       l'ancien en style en ligne pendant 500 ms : on prend le dernier visible. */
    function variantSelects() {
      var all = $$('variant-selects');
      for (var k = all.length - 1; k >= 0; k--) {
        if (all[k].style.display !== 'none') return all[k];
      }
      return null;
    }

    function select(m, fromFree) {
      if (!m) return;
      paintAll(m, fromFree);
      if (currentId() === String(m.id)) return;
      var input = idInput();
      if (input) input.value = m.id;
      var vs = variantSelects();
      var radio = vs && vs.querySelector('input[type="radio"][data-option-value-id="' + m.ov + '"]');
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        try {
          var p = new URLSearchParams(location.search);
          p.set('variant', m.id);
          history.replaceState(history.state, '', location.pathname + '?' + p.toString());
        } catch (e) {}
      }
    }

    amountRadios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        setMsg('');
        select(byFace(parseInt(r.value, 10)));
      });
    });

    /* ---------- « Autre montant » : 50 à 1 000 €, par tranche de 10 € ---------- */
    function setMsg(text, isError) {
      if (!freeMsg) return;
      freeMsg.textContent = text || '';
      freeMsg.hidden = !text;
      /* Un seul message sous le champ : l'arrondi ou l'erreur remplace l'aide. */
      if (freeHelp) freeHelp.hidden = !!text;
      freeMsg.classList.toggle('is-error', !!isError);
      if (freeInput) {
        if (isError) freeInput.setAttribute('aria-invalid', 'true');
        else freeInput.removeAttribute('aria-invalid');
      }
    }
    /* La pastille « Autre montant » est le champ lui-même (revue de finition
       du 26/09) : active dès qu'on y entre, « € » affiché dès qu'il y a un
       chiffre. Les pastilles de montant se décochent pendant la saisie. */
    function paintFreeValue() {
      if (freeRow && freeInput) freeRow.classList.toggle('has-value', !!freeInput.value);
    }
    function markFree() {
      if (freeRadio) freeRadio.checked = true;
      amountRadios.forEach(function (r) { r.checked = false; });
      if (freeRow) freeRow.classList.add('is-active');
    }
    function applyFree(strict) {
      var raw = String(freeInput.value || '').replace(',', '.').trim();
      if (!raw) { if (strict) setMsg(''); return; }
      var amount = parseFloat(raw);
      var map = readMap();
      var cents = Math.round(amount * 100);
      if (isNaN(amount) || cents < map.min || cents > map.max) {
        if (strict) setMsg(data('msg-range'), true);
        return;
      }
      var m = nearest(cents);
      if (!m) { if (strict) setMsg(data('msg-range'), true); return; }
      if (m.c !== cents) {
        if (!strict) return;
        freeInput.value = String(m.c / 100);
        setMsg(data('msg-rounded').split('[a]').join(m.l));
      } else if (strict) {
        setMsg('');
      }
      markFree();
      select(m, true);
    }
    if (freeInput) {
      var timer = null;
      freeInput.addEventListener('focus', markFree);
      /* Sortie du champ sans montant : on revient à la pastille de la variante. */
      freeInput.addEventListener('blur', function () {
        setTimeout(function () { if (!freeInput.value) syncFromVariant(); }, 0);
      });
      freeInput.addEventListener('input', function () {
        clearTimeout(timer);
        paintFreeValue();
        setMsg('');
        timer = setTimeout(function () { applyFree(false); }, 700);
      });
      freeInput.addEventListener('change', function () { clearTimeout(timer); applyFree(true); });
      freeInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); clearTimeout(timer); applyFree(true); }
      });
    }
    if (freeRadio) {
      freeRadio.addEventListener('change', function () {
        if (!freeRadio.checked) return;
        markFree();
        if (freeInput) {
          if (freeInput.value) applyFree(true);
          else freeInput.focus();
        }
      });
    }

    /* ---------- remise en phase depuis la variante réelle ---------- */
    function syncFromVariant() {
      var map = readMap();
      var m = map.byId[currentId()];
      if (m) paintAll(m);
      /* Style de la variante réelle (position de la valeur d'option 1). */
      if (map.si >= 0 && styleRadios[map.si]) {
        styleRadios.forEach(function (r, k) { r.checked = k === map.si; });
        applyStyle(styleRadios[map.si]);
      }
    }
    document.addEventListener('variant:changed', syncFromVariant);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id' && root.contains(e.target)) syncFromVariant();
    });
    window.addEventListener('pageshow', syncFromVariant);

    /* ---------- l'aperçu vivant ---------- */
    var nameIn = root.querySelector('[data-cm-gcr-name]');
    var msgIn = root.querySelector('[data-cm-gcr-message]');
    var dateIn = root.querySelector('[data-cm-gc-send-on]');
    var timeIn = root.querySelector('[data-cm-gc-time]');
    var whoMe = root.querySelector('[data-cm-gcr-who][value="me"]');
    var lang = document.documentElement.lang || 'fr';

    function longDate(v) {
      var p = String(v).split('-');
      if (p.length !== 3) return v;
      try {
        return new Date(+p[0], +p[1] - 1, +p[2]).toLocaleDateString(lang, { day: 'numeric', month: 'long', year: 'numeric' });
      } catch (e) { return v; }
    }

    function paintPreview() {
      var forOther = !(whoMe && whoMe.checked);
      var name = forOther && nameIn ? nameIn.value.trim() : '';
      if (cardTo) cardTo.textContent = name ? data('for').split('[n]').join(name) : '';
      if (note) note.hidden = !forOther;
      if (noteTo) {
        noteTo.textContent = name ? name + ',' : '';
        noteTo.hidden = !name;
      }
      if (noteMsg) {
        var msg = msgIn ? msgIn.value.trim() : '';
        noteMsg.textContent = msg || data('placeholder');
        noteMsg.classList.toggle('is-empty', !msg);
      }
      if (noteSend) {
        var d = dateIn ? dateIn.value : '';
        /* 23/10 : « Envoi le <date>, dès <heure> » quand l'heure d'envoi est
           active (libellé de l'option : « 9 h », « 9 am », « 09:00 ») ; sans
           heure, l'ancienne phrase. */
        var h = '';
        if (d && timeIn && !timeIn.disabled && timeIn.value && timeIn.selectedIndex >= 0) {
          h = (timeIn.options[timeIn.selectedIndex].textContent || '').trim();
        }
        var tplTime = data('send-on-time');
        if (!d) noteSend.textContent = data('send-now');
        else if (h && tplTime) noteSend.textContent = tplTime.split('[d]').join(longDate(d)).split('[h]').join(h);
        else noteSend.textContent = data('send-on').split('[d]').join(longDate(d));
      }
    }
    [nameIn, msgIn, dateIn, timeIn].forEach(function (el) {
      if (!el) return;
      el.addEventListener('input', paintPreview);
      el.addEventListener('change', paintPreview);
    });
    root.addEventListener('cm:gcr:who', paintPreview);

    /* ---------- 6. le paiement express (03/11/2026) ----------
       Le conteneur [data-cmgp-express] ({{ form | payment_button }}) n'est
       visible qu'en « En main propre » : la validation du formulaire
       destinataire ne passe pas par les boutons accélérés (documentation
       Shopify). Bascule sur `cm:gcr:who` (snippets/gift-card-recipient-form) ;
       à l'arrivée et au retour arrière, l'état est relu sur la radio, car le
       script du formulaire a pu dispatcher avant ce fichier (defer). Page sans
       bascule (formulaire destinataire absent) : rien à valider, bouton visible. */
    var express = $('[data-cmgp-express]');
    if (express) {
      var syncExpress = function (e) {
        var whoRadios = $$('[data-cm-gcr-who]');
        var forOther;
        if (e && e.detail && typeof e.detail.forOther === 'boolean') forOther = e.detail.forOther;
        else if (!whoRadios.length) forOther = false;
        else forOther = !(whoMe && whoMe.checked);
        express.hidden = forOther;
      };
      root.addEventListener('cm:gcr:who', syncExpress);
      window.addEventListener('pageshow', function () { syncExpress(); });
      syncExpress();
    }

    /* ---------- le cartouche « Valable jusqu'au <date> » ---------- */
    var cardValid = $('[data-cmgp-card-valid]');
    function validText() {
      var tpl = data('valid');
      if (!tpl) return '';
      var parts = (data('date-intl') || '').split('|');
      var d = new Date();
      d.setFullYear(d.getFullYear() + 1);
      var txt = '';
      try {
        txt = new Intl.DateTimeFormat(parts[0] || lang, { day: parts[1] || 'numeric', month: parts[2] || 'short', year: 'numeric' }).format(d);
      } catch (e) {
        try { txt = d.toLocaleDateString(lang, { day: 'numeric', month: 'short', year: 'numeric' }); } catch (e2) { txt = ''; }
      }
      if (!txt) return '';
      var out = tpl.split('[d]').join(txt);
      /* Grec : le cartouche est en capitales, et les capitales grecques ne
         portent pas d'accent (« ΙΣΧΥΕΙ ΕΩΣ », jamais « ΙΣΧΎΕΙ ΈΩΣ »). On ne
         compte pas sur le navigateur (text-transform le fait dans Chrome,
         pas partout) : NFD, retrait du tonos et des accents (U+0300, U+0301,
         U+0342 ; le tréma U+0308 est gardé), puis NFC. */
      if (/^el\b/i.test(parts[0] || lang) && out.normalize) {
        out = out.normalize('NFD').replace(/[\u0300\u0301\u0342]/g, '').normalize('NFC');
      }
      return out;
    }
    if (cardValid) {
      cardValid.textContent = validText();
      fitCartouche(cardValid);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitCartouche(cardValid); });
      if (window.ResizeObserver) new ResizeObserver(function () { fitCartouche(cardValid); }).observe(cardValid.parentNode);
    }

    /* ---------- le style de la carte (fond + encre) ---------- */
    var face = $('[data-cmgp-face]');
    var styleInput = $('[data-cmgp-style-input]');
    var styleName = $('[data-cmgp-style-name]');
    var styleRadios = $$('[data-cmgp-style]');
    /* Fondu de 150 ms : l'ancien fond est figé dans un calque posé au-dessus
       du nouveau, puis s'efface. Le nouveau fond est déjà en mémoire (voir
       preloadBackgrounds), donc il est là dès le premier cadre. */
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function fadeFrom(oldStyle) {
      if (!face || reduce) return;
      var bg = face.querySelector('.cmgp-card__bg');
      if (!bg) return;
      var ghost = bg.cloneNode(false);
      ghost.className = 'cmgp-card__bg cmgp-card__bg--ghost';
      ghost.style.backgroundImage = getComputedStyle(bg).backgroundImage;
      ghost.style.backgroundColor = getComputedStyle(bg).backgroundColor;
      bg.parentNode.insertBefore(ghost, bg.nextSibling);
      requestAnimationFrame(function () {
        ghost.style.opacity = '0';
        setTimeout(function () { if (ghost.parentNode) ghost.parentNode.removeChild(ghost); }, 200);
      });
    }
    function applyStyle(r) {
      if (!r) return;
      if (face && face.getAttribute('data-style') !== r.value) fadeFrom(face.getAttribute('data-style'));
      if (face) face.setAttribute('data-style', r.value);
      if (styleInput) styleInput.value = r.value;
      if (styleName) styleName.textContent = r.getAttribute('data-name') || r.value;
    }
    /* Choix du visiteur : la variante suit (Style x Montant). Sans option
       Style (ancien produit), seule la face et _style_id changent. */
    function chooseStyle(r) {
      applyStyle(r);
      var map = readMap();
      var idx = parseInt(r.getAttribute('data-index'), 10);
      var entry = map.s[idx];
      if (!entry) return;
      if (map.si === idx && currentId() === String(entry.id)) return;
      var input = idInput();
      if (input && entry.id) input.value = entry.id;
      var vs = variantSelects();
      var radio = vs && vs.querySelector('input[type="radio"][data-option-value-id="' + entry.ov + '"]');
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (entry.id) {
        try {
          var p = new URLSearchParams(location.search);
          p.set('variant', entry.id);
          history.replaceState(history.state, '', location.pathname + '?' + p.toString());
        } catch (e) {}
      }
    }
    function syncStyle() {
      var on = styleRadios.filter(function (r) { return r.checked; })[0] || styleRadios[0];
      applyStyle(on);
    }
    styleRadios.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) chooseStyle(r); });
    });
    /* Le champ caché vit dans le formulaire, hors de <variant-selects> : un
       changement de montant (re-rendu partiel du thème) ne le touche pas.
       `pageshow` couvre le retour arrière : avec l'option Style, la variante
       fait foi (syncFromVariant) ; sans elle, la radio restaurée. */
    window.addEventListener('pageshow', function () {
      if (readMap().si >= 0) syncFromVariant();
      else syncStyle();
    });

    /* Préchargement des fonds : celui du style affiché est déjà demandé par
       le <link rel="preload"> de la section ; les autres le sont une fois la
       page affichée, dans la résolution de l'écran (1x ou @2x), et décodés
       d'avance pour qu'un clic sur une pastille soit instantané. */
    function preloadBackgrounds() {
      var bgs = {};
      try { bgs = JSON.parse(($('[data-cmgp-bgs]') || {}).textContent || '{}'); } catch (e) { bgs = {}; }
      var dense = (window.devicePixelRatio || 1) > 1.25;
      Object.keys(bgs).forEach(function (id) {
        var img = new Image();
        img.decoding = 'async';
        img.src = bgs[id][dense ? 1 : 0];
        if (img.decode) img.decode().catch(function () {});
      });
    }
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 200); };
    if (document.readyState === 'complete') idle(preloadBackgrounds);
    else window.addEventListener('load', function () { idle(preloadBackgrounds); });

    if (readMap().si < 0) syncStyle();
    syncFromVariant();
    paintPreview();
  }

  /* Le cartouche tient dans 47,92 cqw (SPEC v11) : sinon on réduit le corps
     de 1,26 cqw jusqu'à 0,95 cqw au plus bas, puis, en dernier recours, on
     resserre l'espacement (0,34 em vers 0,16 em). Corps exprimé en cqw comme
     la feuille : l'impression et le redimensionnement suivent sans nouveau
     calcul. Même fonction dans templates/gift_card.liquid. */
  function fitCartouche(el) {
    if (!el || !el.textContent) return;
    var card = el.parentNode;
    el.style.letterSpacing = '';
    el.style.fontSize = '';
    var max = card.clientWidth * 0.4792;
    if (!max || el.offsetWidth <= max) return;
    var r = Math.max(0.95 / 1.26, (max / el.offsetWidth) * 0.98);
    el.style.fontSize = 'max(' + (1.26 * r).toFixed(3) + 'cqw, ' + (6 * r).toFixed(2) + 'px)';
    if (el.offsetWidth <= max) return;
    el.style.letterSpacing = '.16em';
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cmgp]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* Éditeur de thème : une section rechargée (réglage modifié) arrive sans
     DOMContentLoaded ; on l'initialise aussi (garde root.__cmgp contre le double). */
  document.addEventListener('shopify:section:load', boot);
})();
